import * as reactRouterRedux from 'react-router-redux';
import * as rr from 'react-router';
// eslint-disable-next-line max-len
export const routerMiddleware = reactRouterRedux.routerMiddleware(process.env.HISTORY === 'hash' ? rr.hashHistory : rr.browserHistory);
export const routing = reactRouterRedux.routerReducer;
